<template>
  <RfPromptsTableView />
</template>

<script setup>
import RfPromptsTableView from "@/views/RfPrompts/RfPromptsTableView.vue";
</script>
